import { API } from "../store"
import handleCatch from "../lib/catch"
import { openSnackBar } from "./snack-bar"

export const createSoloCall = (type, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/solo/${type}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === `${type} created.`) {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createSoloItemCall = (type, id, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/solo/${type}/${id}/item`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteSoloItemCall = (type, item_id) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/billing/solo/${type}/item/${item_id}`)
          .then(response => response.body)
          .then(response => {
            dispatch(openSnackBar({ message: "Item Deleted" }))
            resolve(response)
          })
          .catch(err => {
            dispatch(openSnackBar({ message: "Error deleting item" }))
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
//---------------------------------------
export const deleteSoloRoleCall = (shootRoleId, type) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/billing/solo/${shootRoleId}/role/${type}`)
          .then(response => response.body)
          .then(response => {
            resolve(response)
            dispatch(openSnackBar({ message: "Role Deleted" }))
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
            dispatch(openSnackBar({ message: "Error deleting item" }))
          })
      }
      call()
    })
    return deferred
  }
}

export const createSoloPositionCall = (type, soloId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/solo/${type}/${soloId}/role`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateSolo = (type, id, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/solo/${type}/${id}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === `${type} updated.`) {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateSoloItemCall = (type, item_id, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/solo/${type}/item/${item_id}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const sendSolo = (type, id, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/solo/${type}/${id}/email`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (response.message === `${type} updated.`) {
              resolve(response)
            } else {
              reject(response.error)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getSoloByUniqueString = (type, unique_string) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/billing/solo/${type}/${unique_string}`)
        .then(response => response.body)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const getSoloCall = (type, id) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/billing/${type}/solo/${id}`)
        .then(response => response.body)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const deleteSoloItem = (type, item_id) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.delete(`/billing/solo/${type}/${item_id}`)
        .then(response => response.body)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
            .then(dispatch(openSnackBar({ message: err.message })))
        })
    })
    return deferred
  }
}

export const createShootFromSolo = (type, soloId, shootId) => {
  let data = { shoot_id: shootId }
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/create-shoot/solo/${type}/${soloId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const duplicateSolo = (type, soloId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.post(`/billing/duplicate/solo/${type}/${soloId}`)
        .then(response => response.body)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

// accept, sign, or reject solo
export const updateSoloStatus = (type, soloId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/solo/${type}/status/${soloId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

// accept, sign, or reject solo
export const udpateSoloRole = (type, shootRoleId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/solo/${type}/role/${shootRoleId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
